import { ADA_SUPPORT_TEXT1, ADA_SUPPORT_TEXT2, ADA_SUPPORT_CONTACT } from "utilities/Constant";
import "./ada-footer.scss";
import useDesktopChecker from "hooks/useDesktopChecker";

export const AdaFooter = () => {
  const isDesktop = useDesktopChecker();
  const contactNumber = "tel:8004502010";
  const handleClick = () => {
    if (!isDesktop) {
      window.location.href = contactNumber;
    }
  };
  return (
    <div className="ada-footer">
      <p className="ada-footer--text">
        {ADA_SUPPORT_TEXT1}
        <strong>
          <a className="ada-footer--phone" href={!isDesktop ? contactNumber : undefined} onClick={handleClick} title="phone number">
            {ADA_SUPPORT_CONTACT}
          </a>
        </strong>
        {ADA_SUPPORT_TEXT2}
      </p>
    </div>
  );
};
